import React from 'react'

import declareContext from './declareContext'

const extractProperties = ({ devicePath }) => ({ devicePath })

const AppConfigContext = declareContext(extractProperties)

const useAppConfigContext = AppConfigContext.useContext
const AppConfigProvider = ({ children, ...properties }) => (
  <AppConfigContext.Provider {...properties}>{children}</AppConfigContext.Provider>
)

export { AppConfigProvider, useAppConfigContext }
